export class ProductItem {
    constructor(productFamilyName, productName, attributes = {}) {
        this.attributes = {};
        this.productFamilyName = productFamilyName;
        this.productName = productName;
        this.attributes = attributes;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, value) {
        this.attributes[name] = value;
        return this;
    }
    removeAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    getAttributes() {
        return this.attributes;
    }
    setAttributes(attributes) {
        this.attributes = attributes;
    }
    getProductName() {
        return this.productName;
    }
    getProductFamilyName() {
        return this.productFamilyName;
    }
    reset(json) {
        this.productFamilyName = json['productFamilyName'];
        this.productName = json['productName'];
        this.attributes = json['attributes'];
        return this;
    }
    // Should be rename to "toTestableObject"
    toTestableOneDimensionalArray() {
        const result = {};
        result['item.productFamilyName'] = this.productFamilyName;
        result['item.productName'] = this.productName;
        for (const key in this.attributes) {
            result['item.attributes.' + key] = this.attributes[key];
        }
        return result;
    }
}
